// import React from 'react'
// import './LiveOffer.css'
// import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { Link } from 'react-router-dom'
// import { encodeId } from '../../../utils/common'

// const LiveOffer = ({data}) => {

//     const data1 = [
//         {
//             text: "Raised Foil Business Cards",
//             image: "/assets/Images/Home/LiveOffer/img1.png"
//         },
//         {
//             text: "Premium Finish Business Cards",
//             image: "/assets/Images/Home/LiveOffer/img2.png"
//         },
//         {
//             text: "New Year Hampers",
//             image: "/assets/Images/Home/LiveOffer/img3.png"
//         },
//         {
//             text: "Diary Combo Sets",
//             image: "/assets/Images/Home/LiveOffer/img1.png"
//         },
//         {
//             text: "Diary Combo Sets",
//             image: "/assets/Images/Home/LiveOffer/img2.png"
//         },
//         {
//             text: "Multi Coloured Printed Stand Up Pouches",
//             image: "/assets/Images/Home/LiveOffer/img3.png"
//         },

//     ]

//     return (
//         <section className='LiveOffer'>

//             <div className='container'>
//                 <div className='main_content_holder'>

//                     <div className='content_holder'>
//                         <div className='row me-0 ms-0 align-items-center'>
//                             <div className='col-xl-6 col-lg-7 col-md-12 order-lg-1 order-md-2 order-sm-2 order-2'>

//                                 <div className='heading_conatainer'>
//                                     <p className='heading'>
//                                         <span className='orange_text'>The Offer is Live: </span>
//                                         Grab It Before It’s Gone!
//                                     </p>
//                                 </div>

//                                 <div className='left_side_card_holder'>
//                                     <div className='row'>
//                                         {data?.map((item) => {
//                                             return (
//                                                 <>
//                                                   <Link to={`/product-details-page/${encodeId(item?.id)}`}>
//                                                     <div className='col-6'>
//                                                         <div className='left_side_card'>

//                                                             <div className='row me-0 ms-0'>
//                                                                 <div className='col-sm-3 col-12 p-0'>
//                                                                     <div className='img_holder'>
//                                                                         <img  src={process.env.REACT_APP_IMG_URL+item?.image} className='offer_image' />
//                                                                     </div>
//                                                                 </div>

//                                                                 <div className='col-sm-9 col-12 custom_col'>
//                                                                     <div className='offer_text_holder'>
//                                                                         <p className='offer_text'>{item?.message}</p>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                             <div className='right_icon_holder'>
//                                                                 <FontAwesomeIcon icon={faArrowRight} className="right_arrow" />
//                                                             </div>

//                                                         </div>
//                                                     </div></Link>
//                                                 </>
//                                             )
//                                         })}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className='col-xl-6 col-lg-5 col-md-12 col-md-5 order-lg-2 order-md-1 order-sm-1 order-1'>
//                                 <div className='right_side_img_holder'>
//                                     <img src="/assets/Images/Home/LiveOffer/girl.png" className='right_img' />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </div>

//         </section>
//     )
// }

// export default LiveOffer
import React, { useRef } from "react";
import "./LiveOffer.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function LiveOffer() {
  const swiperRef = useRef(null);

  const products = [
    {
      name: "Raised Foil Business Cards",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "Premium Finish Business Cards",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "New Year Hampers",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "Diary Combo Sets",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },

    {
      name: "Raised Foil Business Cards",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "Premium Finish Business Cards",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "New Year Hampers",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "Diary Combo Sets",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },

    {
      name: "Raised Foil Business Cards",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "Premium Finish Business Cards",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "New Year Hampers",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
    {
      name: "Diary Combo Sets",
      image:
        "/assets/Images/Home/LiveOffer/desk-arrangement-with-coffee-cup.png",
    },
  ];

  return (
    <section className="LiveOffer">
      <div className="custom_container">
        <div className="liveoffer_wrapper">
          <div className="row">
            {/* LEFT SIDE */}
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
              <div className="liveoffer_left">
                <div className="liveoffer_banner">
                  <img
                    src="/assets/Images/Home/LiveOffer/girl_1.png"
                    alt="offer"
                  />
                  <div className="liveoffer_text">LIVE OFFER</div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-xl-8 col-lg-6 col-md-6 col-sm-6">
              <div className="liveoffer_right">
                {/* HEADER */}
                <div className="liveoffer_header">
                  <Homepage_common_heading
                    headingText={"Our Most Popular Picks"}
                    headingDescText={
                      "Popular products that leave a lasting impression."
                    }
                  />

                  {/* CUSTOM ARROWS */}
                  <div className="liveoffer_arrows">
                    <button onClick={() => swiperRef.current?.slidePrev()}>
                      <FaArrowLeft />
                    </button>

                    <button onClick={() => swiperRef.current?.slideNext()}>
                      <FaArrowRight />
                    </button>
                  </div>
                </div>

                {/* PRODUCTS SLIDER */}
                <div className="liveoffer_products">
                  <Swiper
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    className="mySwiper"
                    spaceBetween={20}
                    slidesPerView={3.3}
                    speed={600}
                    grabCursor={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                      },
                      480: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                      1280: {
                        slidesPerView: 3.3,
                        spaceBetween: 20,
                      },
                    }}
                  >
                    {products.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="liveoffer_card">
                          <img src={item.image} alt={item.name} />
                          <div className="liveoffer_overlay">
                            <p>{item.name}</p>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LiveOffer;
